import React, { useState } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Clubs from "./components/Clubs/Clubs";
import ClubsDetail from "./components/ClubsDetail/ClubsDetail";
import ComingSoon from "./components/ComingSoon/ComingSoon";
import Confessions from "./components/Confessions/Confessions";
import Events from "./components/Events/Events";
import EventsDetail from "./components/EventsDetail/EventsDetail";
import Header from "./components/Header/Header";
import "./index.css";

function App() {
  return (
    <Router>
      <div className="flex flex-col h-screen md:flex-row">
        <Header />

        <main className="flex-1 p-6 bg-slate-900 text-white overflow-auto">
          <Routes>
            <Route path="/" element={<Confessions />} />
            <Route path="/wip" element={<ComingSoon />} />
            <Route path="/confessions" element={<Confessions />} />
            <Route path="/clubs" element={<Clubs />} />
            <Route path="/clubs/:id" element={<ClubsDetail />} />
            <Route path="/events" element={<Events />} />
            <Route path="/events/:id" element={<EventsDetail />} />
          </Routes>
        </main>
      </div>
    </Router>
  );
}

export default App;
